"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var consoleLogger_1 = require("./logger/consoleLogger");
var mediumFromBrowserAdapter_1 = require("./datalayer/adapters/mediumFromBrowserAdapter");
var mediumForBrowserAdapter_1 = require("./datalayer/adapters/mediumForBrowserAdapter");
var columnSetFactory_1 = require("./columnSetFactory");
var GroupFieldFactory_1 = require("./datalayer/GroupFieldFactory");
var mmxlCacheAdapter_1 = require("./datalayer/adapters/mmxlCacheAdapter");
var nonPosterDataController_1 = require("./datalayer/nonPosterDataController");
var OutPlacementAdapter_1 = require("./datalayer/adapters/OutPlacementAdapter");
var treeManager_1 = require("./datalayer/treeManager");
var export_1 = require("./export");
var mainLayout_1 = require("./mainLayout");
var mainViewController_1 = require("./mainViewController");
var validation_1 = require("./validation");
var validationSchemas_1 = require("./validationSchemas");
var configuration_1 = require("./configuration");
var Editor = (function () {
    function Editor(canvas, mmxlApi, options, analysisOptions) {
        configuration_1.PlanConfiguration.logger = new consoleLogger_1.ConsoleLogger(consoleLogger_1.LogLevel.warn);
        options = options || {};
        Editor.setMockLoadingHandler(options);
        this._options = options;
        this._zCanvas = new zebra.ui.zCanvas(canvas);
        this._mediumColumnSet = columnSetFactory_1.ColumnSetFactory.getMediumColumnSet();
        if (options.type === "stroer") {
            this._mediumColumnSet = columnSetFactory_1.ColumnSetFactory.getMediumColumnSetStroer();
        }
        this._mmxlLayer = new mmxlCacheAdapter_1.MmxlCacheAdapter(mmxlApi);
        if (this._options.mmxlCaches) {
            this._mmxlLayer.setCaches(this._options.mmxlCaches);
        }
        treeManager_1.TreeManager.setMmxlApi(this._mmxlLayer);
        var columnSet = columnSetFactory_1.ColumnSetFactory.getColumnSet(options.type, options.isDdf, this._options.useTimeClasses);
        this._mainViewController = new mainViewController_1.MainViewController(this._zCanvas.root, new mainLayout_1.MainLayout(), this._mediumColumnSet, columnSet, options);
        this._dataController = new nonPosterDataController_1.NonPosterDataController(this._mainViewController, columnSet, this._mmxlLayer, options, analysisOptions);
        this._mediumGroupValidator = new validation_1.Validator(validationSchemas_1.ValidationSchemas.MEDIUMGROUPS_SCHEMA);
        this._mediumGroupArrayValidator = new validation_1.Validator(validationSchemas_1.ValidationSchemas.MEDIUMGROUPS_SCHEMA_ARRAY);
        this._conditionsValidator = new validation_1.Validator(validationSchemas_1.ValidationSchemas.CONDITIONS_SCHEMA);
        this._audienceValidator = new validation_1.Validator(validationSchemas_1.ValidationSchemas.AUDIENCE_SCHEMA);
        this._calcBaseValidator = new validation_1.Validator(validationSchemas_1.ValidationSchemas.CALCBASE_ARRAY_SCHEMA);
        GroupFieldFactory_1.GroupFieldFactory.setAllowedGroupFields(options.allowedGroupFields);
    }
    Editor.prototype.destroy = function () {
        this._dataController.clearInterval();
    };
    Editor.prototype.getMmxlCaches = function () {
        return this._mmxlLayer.getCaches();
    };
    Editor.prototype.setMmxlCaches = function (caches) {
        this._mmxlLayer.setCaches(caches);
    };
    Editor.prototype.updateTableLayout = function (isDdf) {
        var columnSet = columnSetFactory_1.ColumnSetFactory.getColumnSet(this._options.type, isDdf, this._options.useTimeClasses);
        delete this._mainViewController;
        this._mainViewController = new mainViewController_1.MainViewController(this._zCanvas.root, new mainLayout_1.MainLayout(), this._mediumColumnSet, columnSet, this._options);
        this._dataController.table = this._mainViewController;
        this._options.isDdf = isDdf;
    };
    Editor.setMockLoadingHandler = function (options) {
        if (!options.showLoadingMaskHandler) {
            options.showLoadingMaskHandler = function () { _.noop(); };
        }
        if (!options.hideLoadingMaskHandler) {
            options.hideLoadingMaskHandler = function () { _.noop(); };
        }
    };
    Editor.prototype.setSize = function (width, height) {
        this._zCanvas.setSize(width, height);
    };
    Object.defineProperty(Editor.prototype, "analysis", {
        set: function (analysisId) {
            this._dataController.analysis = analysisId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Editor.prototype, "conditions", {
        set: function (conditions) {
            this._conditionsValidator.validateInputRequest(conditions, "set conditions()");
            this._dataController.conditions = conditions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Editor.prototype, "prefilter", {
        set: function (prefilter) {
            this._audienceValidator.validateInputRequest(prefilter, "set prefilter()");
            this._dataController.prefilter = prefilter;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Editor.prototype, "audience", {
        set: function (audience) {
            this._audienceValidator.validateInputRequest(audience, "set audience()");
            this._dataController.audience = audience;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Editor.prototype, "mediumGroups", {
        get: function () {
            var cloneMediumGroups = _.cloneDeep(this._dataController.plan.mediumGroups);
            this._mediumGroupValidator.validateInputRequest(cloneMediumGroups, "get mediumGroups()");
            var adaptedMediumGroups = [];
            cloneMediumGroups.forEach(function (mg, index) {
                adaptedMediumGroups.push({ mediumGroup: [] });
                mg.mediumGroup.forEach(function (placement) {
                    adaptedMediumGroups[index].mediumGroup.push(new OutPlacementAdapter_1.OutPlacementAdapter(placement));
                });
            });
            return adaptedMediumGroups;
        },
        set: function (mediumGroups) {
            this._mediumGroupArrayValidator.validateInputRequest(mediumGroups, "set mediumGroups()");
            this._dataController.plan = {
                mediumGroups: mediumGroups
            };
        },
        enumerable: true,
        configurable: true
    });
    Editor.prototype.getMediaForBrowser = function () {
        return this._dataController.plan.mediumGroups.map(function (mediumGroup) { return new mediumForBrowserAdapter_1.MediumForBrowserAdapter(mediumGroup); });
    };
    Editor.prototype.setMediaFromBrowser = function (mediaFromBrowser) {
        this._dataController.setMedia(mediaFromBrowser.map(function (medium) { return new mediumFromBrowserAdapter_1.MediumFromBrowserAdapter(medium); }));
    };
    Object.defineProperty(Editor.prototype, "ownTotalPeriod", {
        get: function () {
            var dataControllerDates = this._dataController.ownDdfPeriodTotal[0];
            return [dataControllerDates.from, dataControllerDates.to];
        },
        enumerable: true,
        configurable: true
    });
    Editor.prototype.addMedia = function (media) {
        this._dataController.addMedia(media);
    };
    Object.defineProperty(Editor.prototype, "totalPeriod", {
        set: function (totalPeriod) {
            this._dataController.dates = totalPeriod;
        },
        enumerable: true,
        configurable: true
    });
    Editor.prototype.clearPlan = function () {
        var _this = this;
        return this._dataController.setPlanAndReturnPromise({ mediumGroups: [], calcBase: [] }).then(function () {
            _this._mainViewController.rows = [];
        });
    };
    Object.defineProperty(Editor.prototype, "calcBase", {
        get: function () {
            this._dataController.updateCalcBase();
            var calcBase = this._dataController.plan.calcBase;
            this._calcBaseValidator.validateInputRequest(calcBase, "get calcbase()");
            return calcBase;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Editor.prototype, "columnViews", {
        get: function () {
            return this._mainViewController.columnViews;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Editor.prototype, "planChangedEvent", {
        get: function () {
            return this._dataController.planChangedEvent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Editor.prototype, "viewChangedEvent", {
        get: function () {
            return this._mainViewController.viewChangedEvent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Editor.prototype, "statusChangedEvent", {
        get: function () {
            return this._mainViewController.statusChangedEvent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Editor.prototype, "planInvalidationEvent", {
        get: function () {
            return this._mainViewController.invalidateEvaluationEvent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Editor.prototype, "storedCalcBase", {
        set: function (input) {
            this._calcBaseValidator.validateInputRequest(input, "set storedCalcbase()");
            this._dataController.storedCalcBase = input;
        },
        enumerable: true,
        configurable: true
    });
    Editor.prototype.selectView = function (index, planName) {
        this._mainViewController.onViewSelected(index, planName);
    };
    Editor.prototype.getExportData = function () {
        var columnSets = _.cloneDeep(columnSetFactory_1.ColumnSetFactory.getColumnSet(this._options.type, this._options.isDdf, this._options.useTimeClasses));
        var mediumColumnSet = this._options.type === "stroer"
            ? columnSetFactory_1.ColumnSetFactory.getMediumColumnSetStroer()
            : columnSetFactory_1.ColumnSetFactory.getMediumColumnSet();
        columnSets.forEach(function (columnSet) {
            columnSet.columns.unshift(mediumColumnSet.columns[0]);
        });
        var exportData = {
            columnSets: export_1.Export.exportColumnSets(columnSets, this._mainViewController.planName),
            rows: export_1.Export.exportRows(columnSets, this._mainViewController.rows, this._mainViewController.limitValue),
            selectedViewIndex: this._mainViewController.getViewComboSelectedIndex(),
            totalRow: this.formatTotalRow(this._mainViewController.totalRow, columnSets)
        };
        return exportData;
    };
    Editor.prototype.formatTotalRow = function (totalRow, columnSets) {
        var _this = this;
        var columns = [];
        columnSets.forEach(function (columnSet) {
            columns = columns.concat(columnSet.columns);
        });
        Object.keys(totalRow).forEach(function (key) {
            var correspondingColumn = _.find(columns, function (columnSet) {
                return columnSet["dataPath"] === key;
            });
            if (correspondingColumn) {
                export_1.Export.filterRow(totalRow, correspondingColumn, _this._mainViewController.limitValue);
            }
        });
        return totalRow;
    };
    Editor.prototype.renamePlan = function (newName) {
        this._mainViewController.renamePlan(newName);
    };
    Object.defineProperty(Editor.prototype, "planName", {
        get: function () {
            return this._mainViewController.planName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Editor.prototype, "groupField", {
        set: function (id) {
            this._dataController.groupField = GroupFieldFactory_1.GroupFieldFactory.getGroupField(id);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Editor.prototype, "allowedGroupFields", {
        get: function () {
            return this._options.allowedGroupFields;
        },
        enumerable: true,
        configurable: true
    });
    Editor.prototype.clearGroupField = function () {
        this._dataController.groupField = undefined;
    };
    Object.defineProperty(Editor.prototype, "groupDropDownHandler", {
        set: function (handler) {
            this._mainViewController.addDropDownHandler(handler);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Editor.prototype, "posterData", {
        get: function () {
            return this._posterData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Editor.prototype, "stationData", {
        get: function () {
            return this._stationData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Editor.prototype, "timeOut", {
        set: function (timeOut) {
            this._dataController.setIntervalTimeOut(timeOut);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Editor.prototype, "status", {
        get: function () {
            return this._mainViewController.status;
        },
        enumerable: true,
        configurable: true
    });
    return Editor;
}());
exports.Editor = Editor;
//# sourceMappingURL=Editor.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/Editor.js
// module id = 0
// module chunks = 0